// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  region: 'us-east-1',
  userPoolId: 'us-east-1_cJgEP4C5D',
  userPoolWebClientId: '6np6426pvopnh0ta8lrjg1h857',
  identityPoolId: 'us-east-1:4f085574-3cd1-4fed-8157-6f5d30aa682c',
  signUpBucket: 'rsti-auth-user-signup',
  signInBucket: 'rsti-auth-user-signin', 
  moodleBaseUrl: 'https://lms.rsti-training.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
